import { defineStore } from 'pinia'

interface SafeArea {
  top: number
  bottom: number
}
interface UserInfo {
  token: string
  langType: 'zh' | 'en' | 'ms'
  safeArea: SafeArea
}
interface State {
  userInfo: UserInfo
  requestHeader: any
}

export const useUserStore = defineStore('my_costomer_user', {
  state: (): State => ({
    userInfo: {
      token: '', // pro session_7de50bdc7291ada4
      langType: 'en',
      safeArea: {
        top: 0,
        bottom: 0
      }
    },
    requestHeader: {}
  }),
  actions: {
    setUserInfo(userInfo: UserInfo) {
      this.userInfo = userInfo
    },
    setRequestHeader(requestHeader: any) {
      this.requestHeader = requestHeader
    }
  },
  persist: true
})
